/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 获取操作原因选择项树 的 **请求配置**
 *
 * @分类 财务API/退款
 * @请求头 `GET /modi/system_field/operation_reason_option`
 */
const getOperationReasonOptionRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/modi/system_field/operation_reason_option",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ["key", "query_scope"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOperationReasonOption",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取操作原因选择项树 的 **请求函数**
 *
 * @分类 财务API/退款
 * @请求头 `GET /modi/system_field/operation_reason_option`
 */
export const getOperationReasonOption = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getOperationReasonOptionRequestConfig, requestData),
    ...args
  );
};
getOperationReasonOption.requestConfig = getOperationReasonOptionRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/modi/system_field.js